import styled from '@emotion/styled';

import { neutrals } from '@widget/toolbox/style/theme/common/ThemeProvider/colors';

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  min-height: 126px;
  padding: 16px;
  gap: 24px;
  border-radius: 2px;
  background-color: ${neutrals.contrastText};
`;

export const IconWrap = styled.div`
  padding: 8px;
  & svg {
    fill: none;
    height: 48px;
    width: 48px;
  }
`;

export const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 94px;
`;

export const Value = styled.p`
  max-height: 48px;
  font-size: 24px;
  font-weight: 700;
  line-height: 29.12px;
  margin: 0;
  margin-bottom: 4px;
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 500;
  font-family: Inter;
  line-height: 19.36px;
  margin: 0;
  color: ${neutrals.main};
`;
